import React, { useMemo } from 'react';
import PickingProgressInfoTable from './PickingProgressInfoTable/PickingProgressInfoTable';
import { PickingProgressInfoData } from './PickingProgressInfoTable/PickingProgressInfoTableTypes';
import { PickingProgressStatisticsResponse } from '@ydistri/api-sdk';

interface SourceStoresPickingProgressInfoProps {
  sourceStoresPickingProgress: PickingProgressStatisticsResponse;
}

const SourceStoresPickingProgressInfo: React.FC<SourceStoresPickingProgressInfoProps> = ({
  sourceStoresPickingProgress,
}) => {
  const tableData = useMemo((): PickingProgressInfoData[] => {
    return [
      {
        label: 'Not started',
        value: sourceStoresPickingProgress.notStartedCount,
        description: 'Have not started picking yet.',
      },
      {
        label: 'In progress',
        value: sourceStoresPickingProgress.inProgressCount,
        description: 'Picking has started but not all routes are finished yet.',
      },
      {
        label: 'Finished',
        value: sourceStoresPickingProgress.finishedCount,
        description: 'Picking of all routes is finished.',
        divider: true,
      },
      {
        label: 'Total',
        value: sourceStoresPickingProgress.totalCount,
        isTotal: true,
      },
    ];
  }, [sourceStoresPickingProgress]);

  return (
    <PickingProgressInfoTable
      id="sourceStoresPickingProgressInfo"
      title="Source stores"
      data={tableData}
    />
  );
};

export default SourceStoresPickingProgressInfo;
